module.exports = __webpack_public_path__ + "media/images/logo-01e2eb9f81df808f168f81aefe89f6b5.svg";